<script setup>
import bgSmile from '@/assets/img/bg-smilepicture.png'

import iconBrief from '@/assets/img/icons/icon-brief.png'
import iconConcept from '@/assets/img/icons/icon-conpect.png'
import iconPreProduction from '@/assets/img/icons/icon-pre-production.png'
import iconProduction from '@/assets/img/icons/icon-production.png'
import iconPostProduction from '@/assets/img/icons/icon-post-production.png'

const steps = [
    {
        title: 'Concept',
        desc: 'Every great commercial begins with a powerful idea. Our creative team develops unique concepts that align with your brand identity and transform your message into a compelling visual story.',
        icon: iconConcept,
    },
    {
        title: 'Brief',
        desc: 'We collaborate closely with our clients to understand the campaign goals, target audience, and brand message. This ensures every creative decision is aligned with your marketing vision.',
        icon: iconBrief,
    },
    {
        title: 'Pre-Production',
        desc: 'This stage is where ideas turn into a solid plan. We prepare scripts, storyboards, casting, locations, and technical arrangements to ensure the production runs smoothly and efficiently.',
        icon: iconPreProduction,
    },
    {
        title: 'Production',
        desc: 'Our experienced production team captures high-quality visuals using professional equipment and cinematic techniques to bring your commercial to life.',
        icon: iconProduction,
    },
    {
        title: 'Post Production',
        desc: 'The final stage where everything comes together. Through editing, color grading, sound design, and motion graphics, we craft a polished TV commercial ready for broadcast and digital platforms.',
        icon: iconPostProduction,
    },
]
</script>

<template>
    <section class="wrapper" :style="{
        backgroundImage: `url(${bgSmile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14 py-md-16">
            <h1 class="display-1 mb-3 text-white text-center">
                Our <span class="text-secondary">Process</span>
            </h1>

            <p class="lead text-white text-center mb-10">
                We craft compelling TV commercials through a structured and creative production process. From the first spark of an idea to the final broadcast-ready video, our team ensures every step delivers powerful storytelling and strong brand impact.
            </p>

            <div class="row gx-lg-8 gx-xl-12 gy-6 justify-content-start">
                <div class="col-md-6 col-lg-4 step text-center text-md-start" v-for="(step, i) in steps" :key="i">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <img :src="step.icon" alt="" width="40" height="40" />
                    </span>

                    <h4 class="text-white mb-2">{{ step.title }}</h4>
                    <p class="text-white mb-0">{{ step.desc }}</p>

                    <i class="uil uil-arrow-right step-arrow" v-if="i !== 2 && i !== steps.length - 1" />
                </div>
            </div>
        </div>
    </section>
</template>

<style>
.wrapper {
    position: relative;
}

.btn-soft-primary,
.btn-primary {
    background-color: #ff2eb2 !important;
    border-color: #ff2eb2 !important;
}

.wrapper::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
}

.wrapper>.container {
    position: relative;
    z-index: 1;
}

.process-wrapper.line [class*="col-"]:after {
    border-top-color: transparent;
}

/* Icon step panah */
.step {
    position: relative;
}

.step-arrow {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    color: #ffae0b;
}

.step:last-child .step-arrow {
    display: none;
}

/* ===============================
   HOW WE WORKS RESPONSIVE ARROW
   =============================== */
@media (max-width: 991.98px) {
    .step-arrow {
        display: none;
    }
}
</style>
